import React, { useState, useEffect } from 'react';
import { Container, Card, Spinner, Alert } from 'react-bootstrap';
import { renderInline } from '../utils/richText';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// Minimal markdown rendering for content pages (headers, bullets, bold, links).
// Inline formatting (bold/links, with URL-scheme hardening) is shared with
// user-authored descriptions via renderInline() — see utils/richText.js (#73).
export function renderTermsMarkdown(content) {
  const blocks = [];
  let bullets = [];
  let paragraph = [];

  const flushBullets = (key) => {
    if (bullets.length) {
      blocks.push(<ul key={`ul-${key}`}>{bullets}</ul>);
      bullets = [];
    }
  };
  const flushParagraph = (key) => {
    if (paragraph.length) {
      blocks.push(<p key={`p-${key}`}>{renderInline(paragraph.join(' '), `p-${key}`)}</p>);
      paragraph = [];
    }
  };

  content.split('\n').forEach((line, idx) => {
    const trimmed = line.trim();
    if (trimmed.startsWith('# ')) {
      flushBullets(idx); flushParagraph(idx);
      blocks.push(<h2 key={`h-${idx}`}>{trimmed.slice(2)}</h2>);
    } else if (trimmed.startsWith('## ')) {
      flushBullets(idx); flushParagraph(idx);
      blocks.push(<h4 key={`h-${idx}`} className="mt-4">{trimmed.slice(3)}</h4>);
    } else if (trimmed.startsWith('- ')) {
      flushParagraph(idx);
      bullets.push(<li key={`li-${idx}`}>{renderInline(trimmed.slice(2), `li-${idx}`)}</li>);
    } else if (trimmed === '') {
      flushBullets(idx); flushParagraph(idx);
    } else {
      flushBullets(idx);
      paragraph.push(trimmed);
    }
  });
  flushBullets('end');
  flushParagraph('end');
  return blocks;
}

function Terms() {
  const [terms, setTerms] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/terms`);
        if (!response.ok) throw new Error('Failed to load terms');
        setTerms(await response.json());
      } catch (err) {
        setError('Failed to load the Terms of Use. Please try again later.');
      }
    };
    fetchTerms();
  }, []);

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  if (!terms) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <Container className="mt-4 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <Card>
            <Card.Body className="p-4">
              {renderTermsMarkdown(terms.content)}
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
}

export default Terms;
